<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Mes demandes</span>
        <h3 class="page-title">{{ $t("simple.absence.request.title") }}</h3>
      </div>
    </div>

    <!-- Table -->
    <div class="row">
      <div class="col">
        <div
          class="card card-small mb-4 mt-3"
          v-if="loading || !user.connected"
        >
          <div class="card-body">
            <spinner-dot />
          </div>
        </div>
        <template v-else>
          <step-one-simple
            v-if="step === 1"
            :user.sync="user"
            @input="step = 2"
          />
          <step-two-simple
            v-if="step === 2"
            :user.sync="user"
            :btn-position="btnPosition"
            @input="handleStepTwo"
          />
          <step-four-simple
            v-if="step === 4"
            :user.sync="user"
            :request="request"
            @input="handleStepFour"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import SpinnerDot from '../../components/layout/Loading/spinner-dot';
import StepOneSimple from '../../components/daysOffRequest/simple/StepOne';
import StepTwoSimple from '../../components/daysOffRequest/simple/StepTwo';
import StepFourSimple from '../../components/daysOffRequest/simple/StepFour';

export default {
  name: 'SimpleAbsenceRequest',
  components: {
    StepFourSimple,
    StepTwoSimple,
    StepOneSimple,
    SpinnerDot,
  },
  data() {
    return {
      request: {},
      step: 1,
      loading: false,
    };
  },
  computed: {
    user() {
      return this.$store.state.user.informations;
    },
    btnPosition() {
      const buttonStyle = {
        btnHistoryClass: 'btn-wrapper d-flex justify-content-between',
        btnClass: 'btn-group ml-md-auto mr-md-0 mx-auto',
      };
      return buttonStyle;
    },
  },

  methods: {
    handleStepTwo(dates, motif) {
      if (!dates) {
        this.step = 1;
      } else {
        this.request = dates;
        this.request.motif = motif;
        this.step = 4;
      }
    },

    handleStepFour(totalHours) {
      if (!totalHours) {
        this.step = 2;
      } else {
        this.loading = true;
        const form = {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          userReference: this.user.reference,
          type: 'SIMPLE_ABSENCE',
          dates: [{ to: this.request.to, from: this.request.from }],
          model: {
            reason: this.request.motif,
            totalHours,
          },
        };
        this.$services.absenceRequest.createOne(form).then(() => {
          this.$miniToastr.success(this.$t('days.off.request.success'));
          this.$router.push('/demandes/historique');
        });
      }
    },
  },
};
</script>

<style scoped></style>
